<!--eslint-disable  -->
<template>
  <div class="main-app flex">
    <div v-if="admin && !corpCertityStatus" v-throttle="2000" class="flex-1" @click="goSign">
      您的企业尚未完成实名认证，请<b>立即认证</b> >>
      <!-- 您的企业尚未进行企业实名认证，请尽快进行实名认证，点击此处企业实名认证 >> -->
    </div>
    <div v-if="!admin && !corpCertityStatus" v-throttle="2000" class="flex-1" @click="callSign">
      您的企业尚未进行企业实名认证，请尽快联系管理员进行<b>实名认证</b> >>
    </div>
  </div>
</template>

<script>
import store from '@/store/index';
export default {
  name: '',
  data() {
    return {};
  },
  computed: {
    creator() {
      return store.state.creator;
    },
    admin() {
      return store.state.admin;
    },
    corpCertityStatus() {
      return store.state.corpCertityStatus;
    },
    userCertityStatus() {
      return store.state.userCertityStatus;
    },
    corporationInfo() {
      return store.state.corporationInfo;
    },
  },
  watch: {
    corporationInfo: {
      handler(n) {
        store.commit('updateCorporationInfo', n);
      },
    },
  },
  methods: {
    async goSign() {
      if (this.creator) {
        window.open(window.location.origin + '/admin/location/index');
      } else {
        window.open(window.location.origin + '/admin/authentication/index');
      }
    },
    callSign() {
      this.$message({
        message:
          '您的企业尚未完成实名认证，请联系管理员' +
          ' ' +
          this.corporationInfo.administrator +
          ' ' +
          ':' +
          ' ' +
          this.corporationInfo.administratorPhone +
          ' ' +
          '进行企业实名认证',
        type: 'warning',
        showClose: true,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import url('./right.css');

.main-app {
  .flex-1 {
    height: 40px;
    border-radius: 8px;
    margin-bottom: 10px;
    line-height: 40px;
    background: rgba(255, 244, 240, 1);
    box-shadow: 0px 0px 7px 0px rgba(214, 214, 214, 0.5);
    border-radius: 8px;
    font-size: 14px;
    text-align: center;
    font-weight: 400;
    color: rgba(210, 74, 25, 1);
    cursor: pointer !important;
    box-sizing: content-box;
  }
  .flex-1:hover {
    color: rgba(210, 74, 25, 0.8) !important;
  }
  b {
    padding-bottom: 1px;
    border-bottom: 1px solid rgba(210, 74, 25, 1);
  }
}

@media screen and (max-width: 1910px) {
  .content {
    span {
      width: 110px;
    }
  }
}
@media screen and (max-width: 1679px) {
  .content {
    span {
      width: 150px;
    }
  }
  .main-app {
    display: block;
    .l {
      margin: 0;
    }
  }
}
</style>
